import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Button,
} from 'react-bootstrap5';

import CardButton from './CardButton';

export default function Card({ resource }) {
  const [showFullDescription, setShowFullDescription] = useState(false);

  return (
    <Row className="resource-card gx-0 h-100">
      <Col xl={4} className="pe-3 image-wrapper">
        <div className="icon-wrapper" style={{ backgroundImage: `url(${resource.attributes.preview_url})` }} />
      </Col>
      <Col xl={8} className="content-wrapper">
        <div className="ms-3 me-3">
          <h5 className="title">{resource.attributes.title}</h5>
          <div
            className={`small description ${showFullDescription ? '' : 'short'}`}
          >
            {resource.attributes.description}
          </div>
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="link"
              onClick={() => {
                setShowFullDescription(!showFullDescription);
              }}
            >
              {showFullDescription ? 'Show less' : 'Show more'}
            </Button>

            <CardButton resource={resource} />
          </div>
        </div>
      </Col>
    </Row>
  );
}

Card.propTypes = {
  resource: PropTypes.object.isRequired,
};
